import Swiper, { Navigation, Pagination } from 'swiper';

const uploadSlider = () =>{
  const swiper = new Swiper('.upload-slider', {
    modules: [Navigation, Pagination],
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoHeight: true,
    // slidesPerView: 'auto',
    loop: true
  });
}

document.addEventListener("turbolinks:load", uploadSlider);

export default uploadSlider;